$(document).ready(function () {
    $('.product_carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: true,
        asNavFor: '.product_caroulse_nav',
        infinite: true
    });

    $('.product_caroulse_nav').slick({
        
        // asNavFor: '.product_carousel',
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        vertical: true,
        verticalSwiping: true,
        focusOnSelect: true,
        infinite: false,
    });

    $('.next-arrow').on('click', function(){
        $('.product_carousel').slick('slickNext');
     });
     $('.prev-arrow').on('click', function(){
        $('.product_carousel').slick('slickPrev');
     });

/*      var urlFront = window.location.href;
     var isProductPage = urlFront.includes('/products/t-n-original-mattress')
     if(isProductPage){
       $('#moreInfoHeader').hide();
       $('#learMoreRow').hide();
     } */


        /* This was showing the price in the button, removed the button */
/*      var updateButtonPrice = function(){
        //var productPrice = $('#SingleOptionSelector-0 option:selected').val();
        var a = $('#SingleOptionSelector-0 option:selected').text();
        var priceMattress = a.substring(a.indexOf("$"), a.indexOf("."));
        $('#output').html(priceMattress);
        var s = $('.btn.product-form__cart-submit').val();
  
     }
     updateButtonPrice();
    $('#SingleOptionSelector-0').on('change', function(){
        var welcome = document.getElementById('output');
        var a = $('#SingleOptionSelector-0 option:selected').text();
        var priceMattress = a.substring(a.indexOf("$"), a.indexOf("."));
        welcome.innerHTML = priceMattress;
        //updateButtonPrice();
    })  */

    
    var urlFront = window.location.href;
    var isProductsPage = urlFront.includes('/products/t-n-original-mattress')

    if(isProductsPage){
        var shopButton = $(".tn_button");

        if(shopButton)

        shopButton[0].innerHTML = "Learn More";
        shopButton[1].innerHTML = "Learn More";

        $(shopButton[0]).click(function(e){
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $("#comfTitle").offset().top
            }, 2000);
            
        });

        $(shopButton[1]).click(function(e){
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $("#comfTitle").offset().top
            }, 2000);
        });

        

    }

    function updateBvSummaryPosition() {
        var $content = $('[data-bv-summary-custom-container]');
        if (window.matchMedia("(min-width: 768px)").matches) {
            if ( !($content.parent()[0].hasAttribute('data-bv-summary-desktop-placeholder'))) {
                var $desktopPlaceholder = $('[data-bv-summary-desktop-placeholder]');
                $content.appendTo($desktopPlaceholder);
            }
        } else {
            if ( !($content.parent()[0].hasAttribute('data-bv-summary-mobile-placeholder'))) {
                var $mobilePlaceholder = $('[data-bv-summary-mobile-placeholder]');
                $content.appendTo($mobilePlaceholder);
            }
        }
    }
    $(window).resize(updateBvSummaryPosition);
    updateBvSummaryPosition();


});

